import {
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
  IonLabel,
  IonInput,
  IonPage,
  IonButton,
  IonModal,
} from "@ionic/react";
import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useHistory, useLocation } from "react-router";
import { useRecoilState } from "recoil";
import ErrorTopToaster from "../components/ErrorTopToaster";
import CreateNewLookup from "../components/modals/create-new-lookup";
import PencilIcon from "../components/PencilIcon";
import SelectSectionCustom from "../components/SelectSectionCustom";
import {
  IseditingLookupsState,
  loggedInUserState,
  networkConnectionStatus,
  newAllDropDownState,
  usernameInitialsState,
} from "../data/atoms";
import { ActionType, Lookups } from "../models/Enums";
import { Option } from "../models/Option";
import { User } from "../models/User";
import { EditUserAuth, GetGeneralLookupData } from "../services/AuthServices";
import {
  getFormatedMobileNumber,
  numberValidation,
  verifiyNameWithPattern,
} from "../utils/sharedFunction";
import TopLeftUserName from "../components/TopLeftUserName";
import ResetPasswordModal from "../components/modals/reset-password-modal";
import SuccessModal from "../components/modals/success-modal";
import ExitModal from "../components/modals/exit-modal";

interface Props {
  actionType: any;
}
const EditUserProfile: React.FC<Props> = ({ actionType }) => {
  const modal = useRef<HTMLIonModalElement>(null);
  // console.log("action type top user edit page", actionType)
  // let userToEdit = useRecoilValue(loggedInUserState);
  let [userToEdit, setuserToEditt] = useRecoilState(loggedInUserState);
  // console.log("loggedInUserState: ", loggedInUserState)
  let [userToEdit1, setuserToEdit] = useRecoilState(loggedInUserState);
  let [usernameInitials, setUsernameInitials] = useRecoilState(
    usernameInitialsState
  );

  const [iseditingLookup, setIseditingLookup] = useRecoilState(
    IseditingLookupsState
  );
  const [lookUpType, setLookUpType] = useState<Lookups>(0);
  const [isLookupUpdated, setIsLookupUpdated] = useState(false);
  const [clinicianRole, setClinicianRole] = useState(false);
  const [lookUpOption, setLookUpOption] = useState<boolean>(false);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [lookType, setLookupType] = useState<any>("");
  const [cancelModal, setCancelModal] = useState<boolean>(false);
  const [resetPasswordModal, setResetPasswordModal] = useState<boolean>(false);
  const [successModal, setSuccessModal] = useState<boolean>(false);
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus
  );

  const [newAllDropDown, setNewAllDropDown] =
    useRecoilState(newAllDropDownState);
  const [roleList, setRoleList] = useState<Option[]>([]);
  const location = useLocation();
  // console.log("userToEdit top", userToEdit)

  useEffect(() => {
    // return (() => {
    //   debugger
    //   let ob = newAllDropDown?.roleOpt?.filter((obj: any) => obj.id === userToEdit.clinicianRoleId);
    //   setNewAllDropDown((prevState: any) => ({
    //     ...prevState,
    //     role: ob[0],
    //   }));
    // })
    setuserToEditt(userToEdit);
    initializeClinicianRoleList();
  }, [isLookupUpdated, location, userToEdit?.clinicianRoleId]);

  const {
    register,
    setError,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      firstname: userToEdit?.firstName,
      lastname: userToEdit?.lastName,
      location: userToEdit?.location,
      username: userToEdit?.username,
      // password: userToEdit?.password == null ? "" : userToEdit?.password,
      password: "",
      email: userToEdit?.email,
      country: userToEdit?.country,
      state: userToEdit?.state,
      gender: userToEdit?.gender,
      mobilephone: getFormatedMobileNumber(userToEdit!.mobilePhone),
      officephone: userToEdit?.officePhone,
      address: userToEdit?.address,
      zip: userToEdit?.zip,
      role: userToEdit?.clinicianRoleId,
      businessCode: userToEdit?.businessCode,
      workstationCode: userToEdit?.workstationCode,
      businessName: userToEdit?.businessName,
      workstationName: userToEdit?.workstationName,
    },
  });

  // let SelectedValue = { id: props?.userToEdit?.clinicianRoleId, label: props?.userToEdit?.clinicianRoleName, value: props?.userToEdit?.clinicianRoleName }

  // console.log("bcrypted Password ",bcrypt.hash("123123",10))
  // const bcrypt = require('bcrypt');
  let history = useHistory();

  async function initializeClinicianRoleList() {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    await GetGeneralLookupData({
      localDateTime: new Date(),
      returnReferrals: false,
      returnDepartment: false,
      returnPhysician: false,
      returnTags: false,
      returnDiagnosis: false,
      returnPatientSettings: false,
      clinicianRole: true,
    })
      .then(async function (response) {
        if (response!.data.responseCode === 1) {
          setRoleList(response!.data.clinicianRole);
          Convert(
            response!.data.clinicianRole,
            Lookups.Role,
            "role",
            userToEdit?.clinicianRoleId
          );
          // Convert(response!.data.clinicianRole, Lookups.Role, "role", newAllDropDown?.role ? newAllDropDown?.role.id : userToEdit?.clinicianRoleId);
        } else {
        }
      })
      .catch((error) => {
        // localStorage.setItem("actionType", (ActionType.FailureAPIResponse).toString());
        history.push("/confirmation", {
          actionType: ActionType.FailureAPIResponse,
        });
      });
  }

  const inputNumberVerify = (e: Event, inputField: any) => {
    debugger;
    let verifyZpCode = numberValidation((e.target as HTMLInputElement).value);
    if (!verifyZpCode.isSuccess) {
      setError(inputField, {
        type: "pattern",
        message: ` ${inputField == "zip" ? "Zip Code" : "MRN"}  ${
          verifyZpCode.error
        }`,
      });
    } else {
      setError(inputField, { type: "", message: ` ` });
    }
  };

  function handleImageClick(event: any, element: any, type: Lookups) {
    setIseditingLookup((prevState) => ({
      ...prevState,
      IseditingLookups: true,
      Id: element.id,
      Label: element.name,
      LookUp: type,
    }));
    event.preventDefault();
    event.stopPropagation();
  }

  function Convert(res: any, type: Lookups, str: any, selectedId: any) {
    let ob = res?.filter((obj: any) => obj.id === selectedId);
    if (ob != undefined && ob.length != 0) {
      //update recoil
      setNewAllDropDown((prevState) => ({
        ...prevState,
        role: ob[0],
      }));
    }

    let opt: any = [];
    if (str != "") {
      opt.push({
        id: -1,
        value: "+-- Create a new " + str,
        label: (
          <span className="create-new-tag-click-text">
            {"+ Create a new " + str}
          </span>
        ),
      });
    }
    try {
      res.forEach((element: any) => {
        let Label = element.name;
        if (!element.isDefault) {
          Label = (
            <div className="select-option-custom">
              {" "}
              {element.name}
              <div
                className="pencil-icon"
                onClick={(event: any) => {
                  handleImageClick(event, element, type);
                }}
              >
                <PencilIcon></PencilIcon>
              </div>
            </div>
          );
        }
        let obj = {
          id: element.id,
          value: element.name,
          label: Label,
        };
        opt.push(obj);
      });
    } catch (error) {
      console.log(error);
    }
    setNewAllDropDown((prevState) => ({
      ...prevState,
      roleOpt: opt,
    }));
    // console.log("newAllDropDown :", newAllDropDown)
  }

  const setClinicianRolee = (value: any) => {
    // console.log("value", value)
    setNewAllDropDown((prevState) => ({
      ...prevState,
      role: value,
    }));
  };

  const setLookUp = (edit: boolean, id: number, name: any, type: String) => {
    setLookUpType(Lookups.Role);
    setIseditingLookup((prevState) => ({
      ...prevState,
      IseditingLookups: edit,
      Id: id,
      Label: name,
      LookUp: Lookups.Role,
    }));
    setLookUpOption(true);
  };

  async function EditUser(
    FirstName: string,
    LastName: string,
    Location: string,
    username: string,
    Password: string,
    Email: string,
    Country: string,
    State: string,
    Gender: string,
    MobilePhone: string,
    OfficePhone: string,
    Address: string,
    Zip: string,
    Role: string
  ) {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    const clinicianVM = {} as User;
    // console.log("clinicianVM.password", clinicianVM.password)
    clinicianVM.isPasswordUpdated = Password === "" ? false : true;
    clinicianVM.serverId = userToEdit?.serverId;
    clinicianVM.firstName = FirstName;
    clinicianVM.lastName = LastName;
    clinicianVM.location = Location;
    clinicianVM.username = username;
    clinicianVM.password = Password;
    clinicianVM.email = userToEdit?.email;
    clinicianVM.country = Country;
    clinicianVM.state = State;
    clinicianVM.gender = Gender;
    clinicianVM.workstationCode = userToEdit?.workstationCode;
    clinicianVM.businessCode = userToEdit?.businessCode;
    clinicianVM.workstationName = userToEdit?.workstationName;
    clinicianVM.businessName = userToEdit?.businessName;
    clinicianVM.mobilePhone =
      MobilePhone != null && MobilePhone != undefined
        ? MobilePhone.replace(/-/g, "")
        : "";
    clinicianVM.officePhone =
      OfficePhone != null && OfficePhone != undefined
        ? OfficePhone.replace(/-/g, "")
        : "";
    clinicianVM.address = Address;
    clinicianVM.zip = Zip;
    try {
      clinicianVM.clinicianRoleId =
        newAllDropDown && newAllDropDown.role.id != undefined
          ? newAllDropDown.role.id.toString()
          : "0";
      clinicianVM.clinicianRoleName =
        newAllDropDown && newAllDropDown.role.name != undefined
          ? newAllDropDown.role.name
          : "";
    } catch (e) {
      console.log("Exception caught in EditUser:", e);
    }

    try {
      await EditUserAuth({
        clinicianVM: clinicianVM,
        localDateTime: new Date(),
        EncryptedServerId: localStorage.getItem("EncryptedServerId"),
      })
        .then(async function (response) {
          if (response!.data.responseCode === 1) {
            localStorage.setItem("Username", username);
            localStorage.setItem(
              "UsernameInitials",
              FirstName[0] + LastName[0]
            );

            setuserToEditt(clinicianVM);
            reset({ ...clinicianVM, password: "" });
            setUsernameInitials({
              userName: username,
              initials: FirstName[0] + LastName[0],
            });

            //alert("Reset Password Modal: " + resetPasswordModal);

            if (!resetPasswordModal) {
              history.push("/confirmation", {
                actionType: ActionType.SuccessUpdateUser,
              });
            }
          } else {
            setError("username", {
              type: "server",
              message: response!.data.responseMessage,
            });
          }
          setIsDisabled(false);
        })
        .catch((error) => {
          // localStorage.setItem("actionType", (ActionType.FailureAPIResponse).toString());
          setIsDisabled(false);

          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
        });
    } catch (error) {
      // localStorage.setItem("actionType", (ActionType.FailureAPIResponse).toString());
      setIsDisabled(false);
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      //  console.error(error);
    }
  }

  //This method will check if the userToEdit object is empty or not (black screen issue Fix) //Added by Hasnat
  function isEmpty(obj: Record<string, any>): boolean {
    return Object.keys(obj).length === 0;
  }

  const dismissModal = async (boolean: boolean) => {
    await modal.current?.dismiss();
    setCancelModal(false);
  };

  const dismissPasswordModal = async (value: boolean) => {
    await modal.current?.dismiss();
    setResetPasswordModal(false);
    if (value) {
      setSuccessModal(true);
    }
  };

  const dismissSuccessModal = async (boolean: boolean) => {
    await modal.current?.dismiss();
    setSuccessModal(false);
  };

  return (
    <>
      <IonModal
        className="all-generic-new-modal-center-main-wrap"
        backdropDismiss={false}
        isOpen={resetPasswordModal}
        ref={modal}
        placeholder={undefined}
      >
        <ResetPasswordModal
          setShowModal={dismissPasswordModal}
        ></ResetPasswordModal>
      </IonModal>
      <form
        onSubmit={handleSubmit((data) => {
          // console.log(data);
          setIsDisabled(true);
          EditUser(
            data.firstname,
            data.lastname,
            data.location,
            data.username,
            data.password,
            data.email,
            data.country,
            data.state,
            data.gender,
            data.mobilephone,
            data.officephone,
            data.address,
            data.zip,
            data.role
          );
        })}
        autoComplete="off"
      >
        <IonModal
          className="create-tag-modal"
          backdropDismiss={false}
          isOpen={lookUpOption}
          placeholder={undefined}
        >
          <CreateNewLookup
            setIsLookupUpdated={initializeClinicianRoleList}
            setShowModal2={setLookUpOption}
            LookUpType={lookUpType}
          />
        </IonModal>
        <IonModal
          className="all-generic-new-modal-center-main-wrap"
          backdropDismiss={false}
          isOpen={successModal}
          ref={modal}
          placeholder={undefined}
        >
          <SuccessModal
            setShowModal={dismissSuccessModal}
            actionType={ActionType.SuccessUpdateUserProfile}
          ></SuccessModal>
        </IonModal>
        <IonModal
          className="overall-center-modal-main-wrap"
          backdropDismiss={false}
          isOpen={cancelModal}
          placeholder={undefined}
        >
          <ExitModal
            setShowModal1={setCancelModal}
            actionType={ActionType.EditUserProfile}
            reset={reset}
            isEdit={false}
          ></ExitModal>
        </IonModal>
        <IonPage placeholder={undefined}>
          <TopLeftUserName
            headerText={"Edit User Profile"}
            exitModal={() => setCancelModal(true)}
          ></TopLeftUserName>
          <IonContent placeholder={undefined} className="slide-in-right">
            <IonGrid
              className="container new-edit-user-page"
              placeholder={undefined}
            >
              <IonRow className="row" placeholder={undefined}>
                <IonCol className="col-sec" placeholder={undefined}>
                  {/* Circle Username */}
                  <div className="heading-sec-wrap">
                    <div className="heading-in-circle">
                      {userToEdit !== null &&
                        userToEdit !== undefined &&
                        !isEmpty(userToEdit) && (
                          <h1>
                            {usernameInitials.initials != ""
                              ? usernameInitials.initials
                              : localStorage.getItem("UsernameInitials")}
                          </h1>
                        )}
                    </div>
                    {userToEdit !== null && userToEdit !== undefined && (
                      <h4>
                        {userToEdit!.firstName} {userToEdit!.lastName}
                      </h4>
                    )}
                  </div>
                  {/* Circle Username */}

                  {/* First Name */}
                  <div
                    className={`field-wrap ${errors.firstname && "error-wrap"}`}
                  >
                    <IonLabel className="label" placeholder={undefined}>
                      First Name*
                    </IonLabel>
                    <IonInput
                      className="input-field"
                      type="text"
                      placeholder="Enter First Name"
                      ////value={CustomValue("firstname")}
                      {...register("firstname", {
                        required: true,
                        //  pattern: /^[a-zA-Z0-9\s\$&\+,;\=\@#\'\.\-\^\(\)%!_~`]+$/i,
                        validate: (name) => {
                          // let obj1 = validationNamePattern(name);
                          let obj1 = verifiyNameWithPattern(name);
                          if (!obj1.isSuccess) {
                            return obj1.error.replace("Data", "First");
                          } else {
                            return true;
                          }
                        },
                      })}
                    ></IonInput>
                    {errors?.firstname?.type === "validate" && (
                      <p className="error-msg">{errors.firstname.message}</p>
                    )}
                    {errors?.firstname?.type === "required" && (
                      <p className="error-msg">This field is required</p>
                    )}
                    {errors.firstname &&
                      errors.firstname.type !== "required" &&
                      errors.firstname.type === "server" &&
                      errors.firstname.message && (
                        <ErrorTopToaster
                          errorString={errors.firstname.message}
                        />
                      )}
                  </div>
                  {/* First Name */}

                  {/* Last Name */}
                  <div
                    className={`field-wrap ${errors.lastname && "error-wrap"}`}
                  >
                    <IonLabel className="label" placeholder={undefined}>
                      Last Name*
                    </IonLabel>
                    <IonInput
                      className="input-field"
                      type="text"
                      placeholder="Enter Last Name"
                      //value={CustomValue("lastname")}
                      {...register("lastname", {
                        required: true,
                        // pattern: /^[a-zA-Z0-9\s\$&\+,;\=\@#\'\.\-\^\(\)%!_~`]+$/i,
                        // validate: {
                        //   hasSpecialChar: /^([!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])+[\W\w\d]*$/,
                        //   hasNumbers: numbersRegex.test,
                        //   // ...
                        // }
                        validate: (name) => {
                          // let obj1 = validationNamePattern(name);
                          let obj1 = verifiyNameWithPattern(name);
                          if (!obj1.isSuccess) {
                            return obj1.error.replace("Data", "Last");
                          } else {
                            return true;
                          }
                        },
                      })}
                    ></IonInput>
                    {errors?.lastname?.type === "required" && (
                      <p className="error-msg">This field is required</p>
                    )}
                    {errors.lastname &&
                      errors.lastname.type !== "required" &&
                      errors.lastname.type === "server" &&
                      errors.lastname.message && (
                        <ErrorTopToaster
                          errorString={errors.lastname.message}
                        />
                      )}
                    {errors?.lastname?.type === "validate" && (
                      <p className="error-msg">{errors.lastname.message}</p>
                    )}
                  </div>
                  {/* Last Name */}

                  {/* Phone number */}
                  <div
                    className={`field-wrap ${
                      errors.mobilephone && "error-wrap"
                    }`}
                  >
                    <IonLabel className="label" placeholder={undefined}>
                      Phone Number*
                    </IonLabel>
                    <IonInput
                      className="input-field"
                      type="text"
                      placeholder="(XXX) XXX-XXXX"
                      onIonChange={(e: any) => {
                        if (e.target.value.length <= 13) {
                          if (
                            e.target.value.length == 3 &&
                            userToEdit1?.mobilePhone?.indexOf("-") == -1
                          ) {
                            e.target.value = e.target.value + "-";
                          } else if (
                            e.target.value.length == 7 &&
                            userToEdit1?.mobilePhone?.lastIndexOf("-") == 3
                          ) {
                            e.target.value = e.target.value + "-";
                          }
                          setuserToEdit((prevState) => ({
                            ...prevState,
                            mobilePhone: e.target.value,
                          }));
                        } else {
                          e.target.value = userToEdit1.mobilePhone;
                        }
                      }}
                      //value={CustomValue("mobilephone")}
                      {...register("mobilephone", {
                        required: true,
                        pattern:
                          /^([0-9]( |-)?)?(\(?[0-9]{3}\)?|[0-9]{3})( |-)?([0-9]{3}( |-)?[0-9]{4,5})$/,
                      })}
                    ></IonInput>
                    {errors?.mobilephone?.type === "required" && (
                      <p className="error-msg">This field is required</p>
                    )}
                    {errors.mobilephone &&
                      (errors.mobilephone.type as unknown) == "pattern" && (
                        <p className="error-msg">Invalid Mobile phone number</p>
                      )}

                    {errors.mobilephone &&
                      errors.mobilephone.type !== "required" &&
                      errors.mobilephone.type === "server" &&
                      errors.mobilephone.message && (
                        <ErrorTopToaster
                          errorString={errors.mobilephone.message}
                        />
                      )}
                  </div>
                  {/* Phone number */}

                  {/* Role */}
                  {newAllDropDown && (
                    <div className="field-wrap">
                      <IonLabel className="label" placeholder={undefined}>
                        Clinician Role
                      </IonLabel>
                      <SelectSectionCustom
                        isEdit={true}
                        placeholder="Select a Role"
                        isSearchable={false}
                        isEditableOption={true}
                        allOptions={roleList}
                        value={""}
                        LookUpType={"Role"}
                        onSelectOption={setClinicianRolee}
                        onAddOrEditLookUp={setLookUp}
                        isMultiSelect={false}
                      />

                      {/* <CustomSelect setNewAllDropDownInPatienrDetails={setuserToEdit} isLookupUpdated={isLookupUpdated} setIsLookupUpdated={setIsLookupUpdated} setSelectedOption={setNewAllDropDown} isArray={false} LookUpType={Lookups.Role} ></CustomSelect> */}
                      {/* <CustomSelect setOption={setDepartment}></CustomSelect> */}
                    </div>
                  )}
                  {/* Role */}

                  {/* Zip Code */}
                  <div
                    className={`field-wrap ${
                      errors.zip?.type.length && "error-wrap"
                    }`}
                  >
                    <IonLabel className="label" placeholder={undefined}>
                      Zip Code*
                    </IonLabel>
                    <IonInput
                      className="input-field"
                      type="text"
                      placeholder="Enter Zip Code"
                      onIonChange={(e: any) => {
                        inputNumberVerify(e, "zip");
                      }}
                      // value={CustomValue("Zip")}
                      {...register("zip", {
                        required: true,
                        pattern: /^\d+$/,
                      })}
                    ></IonInput>
                    {errors?.zip?.type === "required" && (
                      <p className="error-msg">This field is required</p>
                    )}
                    {errors?.zip?.type === "pattern" && (
                      <p className="error-msg">Zip Code must be numeric</p>
                    )}
                    {errors.zip &&
                      errors.zip.type !== "required" &&
                      errors.zip.type === "server" &&
                      errors.zip.message && (
                        <ErrorTopToaster errorString={errors.zip.message} />
                      )}
                  </div>
                  {/* Zip Code */}

                  {/* Email */}
                  <div
                    className={`field-wrap disabled ${
                      errors.email && "error-wrap"
                    }`}
                  >
                    <IonLabel className="label" placeholder={undefined}>
                      Email*
                    </IonLabel>
                    <IonInput
                      className="input-field"
                      type="email"
                      placeholder="Enter email"
                      disabled={true}
                      //value="test@gmail.com"
                      //value={CustomValue("email")}
                      {...register("email", {
                        required: true,
                      })}
                      readonly
                    ></IonInput>
                  </div>
                  {/* Email */}

                  {/* Username */}
                  {/* <div
                    className={`field-wrap ${errors.username && "error-wrap"}`}
                  >
                    <IonLabel className="label" placeholder={undefined}>
                      Username*
                    </IonLabel>
                    <IonInput
                      className="input-field"
                      type="text"
                      placeholder="Enter username"
                      //value={CustomValue("username")}
                      {...register("username", {
                        required: true,
                        // pattern: /^[a-zA-Z0-9]+[@.#$%^&\-+_ a-zA-Z0-9]*$/,
                        validate: (name) => {
                          // let obj1 = validationNamePattern(name);
                          let obj1 = verifiyNameWithPattern(name);
                          if (!obj1.isSuccess) {
                            return obj1.error.replace("Data", "User");
                          } else {
                            return true;
                          }
                        },
                      })}
                    ></IonInput>
                    {errors?.username?.type === "validate" && (
                      <p className="error-msg">{errors.username.message}</p>
                    )}
                    {errors?.username?.type === "required" && (
                      <p className="error-msg">This field is required</p>
                    )}
                    {errors.username &&
                      errors.username.type !== "required" &&
                      errors.username.type === "server" &&
                      errors.username.message && (
                        <ErrorTopToaster
                          errorString={errors.username.message}
                        />
                      )}
                  </div> */}
                  {/* Username */}

                  {/* Password */}
                  <div
                    className={`field-wrap disabled ${
                      errors.password && "error-wrap"
                    }`}
                  >
                    <IonLabel className="label" placeholder={undefined}>
                      {" "}
                      Password*
                    </IonLabel>
                    <div className="input-field-with-icon">
                      <IonInput
                        className="input-field clinician-password"
                        type="password"
                        readonly={true}
                        disabled={true}
                        placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
                        //value={CustomValue("password")}
                        // {...register("password", {
                        //   required:
                        //     actionType?.actionType == ActionType.EditClinician
                        //       ? false
                        //       : true,
                        //   pattern:
                        //     /^(?=.*[!@#$%^&*_0-9])(?=.*[A-Z])([^\\s])[a-zA-Z0-9!@#$%^&*._]{7,}$/,
                        // })}
                      ></IonInput>

                      <svg
                        onClick={() => setResetPasswordModal(true)}
                        className="new-pencil-icon no-disabled"
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M14.9692 9.48643L6.26062 18.195C6.08351 18.3721 5.84328 18.4716 5.5928 18.4716H1.47228C0.950674 18.4716 0.527832 18.0488 0.527832 17.5272L0.527832 13.4067C0.527832 13.1562 0.627336 12.916 0.804453 12.7388L12.4376 1.10568C13.2087 0.334564 14.459 0.334564 15.2301 1.10568L17.8938 3.76938C18.6649 4.5405 18.6649 5.79074 17.8938 6.56185L14.9786 9.47706C14.977 9.47863 14.9755 9.4802 14.9739 9.48176C14.9723 9.48332 14.9708 9.48488 14.9692 9.48643ZM13.7733 2.44133C13.8067 2.40787 13.861 2.40787 13.8944 2.44133L16.5581 5.10503C16.5916 5.13849 16.5916 5.19274 16.5581 5.22621L14.3061 7.47828L11.5212 4.6934L13.7733 2.44133ZM10.1855 6.02904L2.41672 13.7979V16.5827H5.2016L12.9704 8.81392L10.1855 6.02904Z"
                          fill="#802392"
                        />
                      </svg>
                    </div>

                    {errors?.password?.type === "required" && (
                      <p className="error-msg">This field is required</p>
                    )}
                    {errors.password && errors.password.type === "pattern" && (
                      <ErrorTopToaster
                        errorString={"Password does not meet criteria"}
                      />
                    )}
                    {errors.password &&
                      errors.password.type !== "required" &&
                      errors.password.type === "server" &&
                      errors.password.message && (
                        <ErrorTopToaster
                          errorString={errors.password.message}
                        />
                      )}
                  </div>
                  {/* Password */}

                  {/* (Only for Branch Admin - should match the Cloud Location name) */}
                  {/* https://virtusense.visualstudio.com/VSTBalance/_workitems/edit/9797 */}

                  {/* <div className={`field-wrap ${errors.role && "error-wrap"
                  }`}>
                  <IonLabel className="label">Role*</IonLabel>
                  <IonInput
                    className="input-field"
                    type="text"
                    placeholder="Enter Role"
                    //value={CustomValue("role")}
                    {...register("role", {
                      required: true,
                      //  pattern: /^[A-Za-z]+$/i,
                    })}
                  ></IonInput>
                  {errors?.role?.type === "required" && (
                    <p className="error-msg">This field is required</p>
                  )}
                  {errors.role &&
                    errors.role.type !== "required" &&
                    errors.role.type === "server" &&
                    errors.role.message && (
                      <ErrorTopToaster errorString={errors.role.message} />
                    )
                  }
                </div> */}

                  {/* <div className={`field-wrap ${errors.state && "error-wrap"
                  }`}>
                  <IonLabel className="label">State*</IonLabel>
                  <IonInput
                    className="input-field"
                    type="text"
                    placeholder="Enter state"
                    //value={CustomValue("state")}
                    {...register("state", {
                      required: true,
                      //  pattern: /^[A-Za-z]+$/i,
                    })}
                  ></IonInput>
                  {errors?.state?.type === "required" && (
                    <p className="error-msg">This field is required</p>
                  )}
                  {errors.state &&
                    errors.state.type !== "required" &&
                    errors.state.type === "server" &&
                    errors.state.message && (
                      <ErrorTopToaster errorString={errors.state.message} />
                    )
                  }
                </div> */}
                  {/* <div className="field-wrap">
                  <IonLabel className="label">Gender</IonLabel>
                  <IonSelect
                    placeholder="Select Gender"
                    className="input-field custom-select"
                    //value={CustomValue("gender")}
                    {...register("gender", {
                      required: true,
                      //  pattern: /^[A-Za-z]+$/i,
                    })}
                  >
                    <IonSelectOption value="male">Male</IonSelectOption>
                    <IonSelectOption value="oranges">Female</IonSelectOption>
                  </IonSelect>
                </div> */}

                  {/* <div className={`field-wrap ${errors.officephone && "error-wrap"
                  }`}>
                  <IonLabel className="label">Office Phone*</IonLabel>
                  <IonInput
                    className="input-field"
                    type="text"
                    placeholder="Enter office phone"
                    //value={CustomValue("officephone")}
                    {...register("officephone", {
                      required: true,
                      //  pattern: /^[A-Za-z]+$/i,
                    })}
                  ></IonInput>
                  {errors?.officephone?.type === "required" && (
                    <p className="error-msg">This field is required</p>
                  )}
                  {errors.officephone &&
                    errors.officephone.type !== "required" &&
                    errors.officephone.type === "server" &&
                    errors.officephone.message && (
                      <ErrorTopToaster errorString={errors.officephone.message} />
                    )
                  }
                </div> */}
                  {/* <div className={`field-wrap ${errors.address && "error-wrap"
                  }`}>
                  <IonLabel className="label">Address*</IonLabel>
                  <IonInput
                    className="input-field"
                    type="text"
                    placeholder="Enter address"
                    //value={CustomValue("address")}
                    {...register("address", {
                      required: true,
                      //  pattern: /^[A-Za-z]+$/i,
                    })}
                  ></IonInput>
                </div>
                <div className={`field-wrap ${errors.zip && "error-wrap"
                  }`}>
                  <IonLabel className="label"> Zip*</IonLabel>
                  <IonInput
                    className="input-field"
                    type="number"
                    placeholder="Enter zip"
                    //value={CustomValue("zip")}
                    {...register("zip", {
                      required: true,
                      //  pattern: /^[A-Za-z]+$/i,
                    })}
                  ></IonInput>
                  {errors?.zip?.type === "required" && (
                    <p className="error-msg">This field is required</p>
                  )}
                  {errors.zip &&
                    errors.zip.type !== "required" &&
                    errors.zip.type === "server" &&
                    errors.zip.message && (
                      <ErrorTopToaster errorString={errors.zip.message} />
                    )
                  }
                </div> */}
                  <div className="btn-wrap-sec two-btns">
                    <IonButton
                      // onClick={() => history.push("/user-profile")}
                      onClick={() => setCancelModal(true)}
                      // onClick={() => {
                      //   history.replace("/confirmation", {
                      //     actionType: ActionType.EditUserProfile,
                      //   });
                      // }}
                      disabled={cancelModal ? true : false}
                      className="generic-btn generic-btn-outline"
                      placeholder={undefined}
                    >
                      Cancel
                    </IonButton>
                    <IonButton
                      className="generic-btn"
                      type="submit"
                      placeholder={undefined}
                      disabled={isDisabled}
                    >
                      Save
                    </IonButton>
                  </div>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonContent>
        </IonPage>
      </form>
    </>
  );
};
export default EditUserProfile;
